export default __webpack_public_path__ + "static/sweatshirt-results-1-085b8e18bc73fdff6b77059ccf099dd5.png";